import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    solarGraphData: undefined,
    solarGraphInterval: undefined
  },
  getters: {
    solarGraphData (state) {
      return state.solarGraphData
    }
  },
  mutations: {
    updateSolarGraphData (state, solarData) {
      state.solarGraphData = solarData
    },
    updateSolarSetInverval (state, anInterval) {
      console.log('setInterval: ', anInterval)
      if (state.solarGraphInterval !== undefined) {
        console.log('interval exisits clearing old interval:  ', state.solarGraphInterval)
        clearInterval(state.solarGraphInterval)
      }
      state.solarGraphInterval = anInterval
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js